import { render, staticRenderFns } from "./SvgEyeglass.vue?vue&type=template&id=38e7791d&lang=pug&"
import script from "./SvgEyeglass.vue?vue&type=script&lang=js&"
export * from "./SvgEyeglass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports